import { AudioManager } from "../../../AudioManager";
import { GameConstants } from "../../../GameConstants";
import { GameManager } from "../../../GameManager";
import { GameVars } from "../../../GameVars";
import { ButtonWithText } from "../../../utils/ButtonWithText";
import { BoardManager } from "../BoardManger";
import { NextCardContainer } from "./NextCardContainer";

export class GameOverLayer extends Phaser.GameObjects.Container {

    private nextCardContainer: NextCardContainer;
    private goldLabel: Phaser.GameObjects.Text;
    private goldCounter: number;
    private rewardedAdsButton: ButtonWithText;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        const goldContainer = new Phaser.GameObjects.Container(this.scene);
        goldContainer.x = 682;
        goldContainer.y = 40 * GameVars.scaleY;
        goldContainer.scaleY = GameVars.scaleY;
        this.add(goldContainer);

        const goldContainerCapsule = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "tab_coin_balance");  
        goldContainerCapsule.setScale(1.35);
        goldContainer.add(goldContainerCapsule);

        this.goldLabel = new Phaser.GameObjects.Text(scene, 25, -6, "-", {fontFamily: "AlmendraBold", color: "#663227", fontSize: "42px"});
        this.goldLabel.setOrigin(1, .5);
        goldContainer.add(this.goldLabel);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const resultLabel = new Phaser.GameObjects.Text(this.scene, 0, -70, "", { fontFamily: "AlmendraBold", fontSize: "68px", color: "#000000" });
        resultLabel.setOrigin(.5);
        scaledItemsContainer.add(resultLabel);

        if (GameVars.victory) {

            resultLabel.text = text.SUCCESSFUL_RAID[lan];
            resultLabel.setStroke("#5a2b13", 8);
           
            const gradient = resultLabel.context.createLinearGradient(0, 0, 0, resultLabel.height);
            gradient.addColorStop(0, "#fff95c");
            gradient.addColorStop(1, "#fab34d");
            resultLabel.setFill(gradient);

            const state = GameVars.cardCrawlEngine.getState();
            this.goldLabel.text = GameVars.formatNumber(GameVars.gameData.gold - state.lowerTableau[1].gold);
            
        } else {

            resultLabel.text = text.YOU_DIED[lan];
            resultLabel.setFontSize("82px");
            resultLabel.setStroke("#781628", 10);
           
            const gradient = resultLabel.context.createLinearGradient(0, 0, 0, resultLabel.height);
            gradient.addColorStop(0, "#fd3c4f");
            gradient.addColorStop(1, "#d33241");
            resultLabel.setFill(gradient);

            this.goldLabel.text = GameVars.formatNumber(GameVars.gameData.gold);
        }

        if (this.goldLabel.width > 85) {
            this.goldLabel.setScale(85 / this.goldLabel.width);
        }

        if (resultLabel.width > 650) {
            resultLabel.scale = 650 / resultLabel.width;
        }

        const nextButtonLabel = new Phaser.GameObjects.Text(scene, 0, -4, text.NEXT[lan], {fontFamily: "AlmendraBold", color: "#663227", fontSize: "48px"});
        nextButtonLabel.setOrigin(.5);

        if (nextButtonLabel.width > 145) {
            nextButtonLabel.scale = 145 / nextButtonLabel.width;
        }
       
        const nextButtonImage = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "btn_next_game_over");

        const nextButton = new ButtonWithText(scene, nextButtonImage, nextButtonLabel, this.onClickNext, this);
        nextButton.y = 390;
        scaledItemsContainer.add(nextButton);

        this.nextCardContainer = new NextCardContainer(this.scene);
        this.add(this.nextCardContainer);

        scaledItemsContainer.alpha = 0;

        this.scene.tweens.add({
            targets: scaledItemsContainer,
            alpha: 1,
            duration: 500,
            delay: 3000,
            ease: Phaser.Math.Easing.Cubic.Out
        });

        if (GameConstants.HAS_REWARDED_ADS) {

            nextButton.y = 345;

            const rewardedAdLabel = new Phaser.GameObjects.Text(scene, -42, -10, "+" + GameConstants.REWARDED_AD_EXTRA_GOLD, {fontFamily: "AlmendraBold", color: "#ffee59", fontSize: "40px"});
            rewardedAdLabel.setOrigin(.5);
            rewardedAdLabel.setStroke("#6c3510", 6);

            const rewardedAdImage  = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "btn_rewarded_ad_game_over");

            this.rewardedAdsButton = new ButtonWithText(scene, rewardedAdImage, rewardedAdLabel, () => {
                this.onClickRewardedAdBtn();
            }, this);
            this.rewardedAdsButton.y = 450;
            scaledItemsContainer.add(this.rewardedAdsButton);
        }

        this.nextCardContainer = new NextCardContainer(this.scene);
        this.add(this.nextCardContainer);
    }

    public updateGold(duration: number, delay: number, rewardedAd?: boolean): void {

        if (rewardedAd) {

            this.goldCounter = GameVars.gameData.gold - GameConstants.REWARDED_AD_EXTRA_GOLD;

            this.scene.tweens.add({
                targets: this.goldLabel,
                scaleX: 1.15,
                scaleY: 1.15,
                duration: 250,
                delay: delay / 2,
                ease: Phaser.Math.Easing.Cubic.Out,
                yoyo: true,
            });

        } else {
            this.goldCounter = GameVars.gameData.gold - GameVars.cardCrawlEngine.getState().lowerTableau[1].gold;
        }

        this.scene.tweens.add({
            targets: this,
            goldCounter: GameVars.gameData.gold,
            duration: duration,
            delay: delay,
            onUpdate: () => {
                this.goldLabel.text = GameVars.formatNumber(Math.floor(this.goldCounter));
            },
            onUpdateScope: this
        });
    }

    private onClickNext(): void {

        GameManager.enterSplashScene();

        AudioManager.playSound("btn_click");
    }

    private onClickRewardedAdBtn(): void {

        this.rewardedAdsButton.visible = false;

        this.scene.time.delayedCall(1000, () => {
            BoardManager.onGameOverRewardedAdShown();
        }, [], this);
    }
}
